import { makeStyles } from '@material-ui/core';
import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: '100%',
    minHeight: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px 8px',
    boxSizing: 'border-box',
  },
  link: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    color: 'inherit',
  },
  image: {
    display: 'block',
    width: '100%',
    maxWidth: 164,
    height: 'auto',
    objectFit: 'contain',
  },
  imageCollapsed: {
    width: 44,
    maxWidth: 44,
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        <img
          className={isOpen ? classes.image : `${classes.image} ${classes.imageCollapsed}`}
          src="/logo_vwtech_.png"
          alt="vw tech"
        />
      </Link>
    </div>
  );
};
